import React from "react";

export type BrokerageAssociationSource = {
  brokerage_association_status?: string;
  brokerage_association_resource_type?: string;
  brokerageAssociationStatus?: string;
  brokerageAssociationResourceType?: string;
} | null | undefined;

export function readBrokerageAssociationFields(source: BrokerageAssociationSource) {
  return {
    status: String(
      source?.brokerage_association_status ||
        source?.brokerageAssociationStatus ||
        ""
    ).trim(),
    resourceType: String(
      source?.brokerage_association_resource_type ||
        source?.brokerageAssociationResourceType ||
        ""
    ).trim(),
  };
}

export function getBrokerageAssociationShortStatus(
  status?: string | null,
  resourceType?: string | null
): string | null {
  const s = String(status || "").trim().toUpperCase();
  const t = String(resourceType || "").trim().toLowerCase();
  if (!s) return null;
  if (s === "PENDING" || s === "PROCESSING") return "Pending Brokerage Approval";
  if (s === "REJECTED") {
    if (t === "agent") return "Agent Declined";
    if (t === "team_member") return "Team Member Declined";
    if (t === "office") return "Office Declined";
    return "Declined";
  }
  return null;
}

function badgeColors(label: string): { bg: string; color: string } {
  if (label === "Pending Brokerage Approval") {
    return { bg: "#ffe0b3", color: "#b76b00" };
  }
  return { bg: "#fddede", color: "#d93025" };
}

type BrokerageAssociationStatusBadgeProps = {
  source?: BrokerageAssociationSource;
  status?: string | null;
  resourceType?: string | null;
  className?: string;
};

const BrokerageAssociationStatusBadge: React.FC<BrokerageAssociationStatusBadgeProps> = ({
  source,
  status,
  resourceType,
  className,
}) => {
  const fields = readBrokerageAssociationFields(source);
  const label = getBrokerageAssociationShortStatus(
    status ?? fields.status,
    resourceType ?? fields.resourceType
  );
  if (!label) return null;

  const colors = badgeColors(label);

  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 8px",
        borderRadius: "999px",
        backgroundColor: colors.bg,
        color: colors.color,
        border: `0.2px solid ${colors.color}50`,
        fontSize: "0.75rem",
        fontWeight: 600,
        lineHeight: 1.3,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
};

export default BrokerageAssociationStatusBadge;
